<div class="poster-image-wrapper position-relative">
    <app-sensitive-content-container
        *ngIf="isCautionFlagContainerDisplayed"
        [customAction]="true"
        [actionButtonName]="cautionFlagButtonName"
        (customActionTrigger)="expand()"
        class="content-flags-overlay"
    >
    </app-sensitive-content-container>
    <div
        class="image-container"
        [ngStyle]="{ 'background-image': 'url(\'' + documentMedia.posterImage.itsURL + '\')' }"
        [title]="documentMedia.posterImage.getAltText()"
    >
        <div class="p-2 notification-bar text-center" *ngIf="addOnViewService.isAddonView">
            This resource will launch in a separate browser window. Please return to Google
            Classroom to complete your work.
        </div>
        <span class="expand" (click)="expand()">
            <div class="view-button">View <app-icon type="External-link"></app-icon></div>
        </span>
    </div>
</div>
